/* eslint-disable @typescript-eslint/camelcase */
import { LangCodes } from '@skbkontur/react-ui/lib/locale';
import { LocaleHelper } from '@skbkontur/react-ui/lib/locale/LocaleHelper';
import { componentsLocales as ru_RU } from './locales/ru';
export * from './types';
export var FiasLocaleHelper = new LocaleHelper({ ru_RU: ru_RU }, LangCodes.ru_RU);
